export default __webpack_public_path__ + "static/media/Poly feed 2.056fb9da.jpg";